import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ProjectProvider } from './context/ProjectContext';
import AdminLayout from './components/AdminLayout';
import Login from './pages/Login';
import ProductBasicInfo from './pages/demo/ProductBasicInfo';
import ProductSkillPage from './pages/demo/ProductSkillPage';
import AIDirector from './pages/director/AIDirector';
import AIReview from './pages/review/AIReview';
import AIGenerate from './pages/generate/AIGenerate';
import AccountAdmin from './pages/admin/AccountAdmin';
import AIProviderAdmin from './pages/admin/AIProviderAdmin';
import './App.css';

// 登录门禁：未登录只显示登录页；本系统无注册，账号由管理员创建
const AppInner: React.FC = () => {
  const { user, checking } = useAuth();

  if (checking) {
    return (
      <div className="app-splash">
        <p>快推 AI · 智能投放平台 加载中...</p>
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  return (
    <ProjectProvider>
      <Routes>
        <Route path="/" element={<AdminLayout />}>
          <Route index element={<Navigate to="/overview" replace />} />
          <Route path="overview" element={<ProductBasicInfo />} />
          <Route path="analysis" element={<ProductSkillPage />} />
          <Route path="strategy" element={<AIDirector />} />
          <Route path="review" element={<AIReview />} />
          <Route path="generate" element={<AIGenerate />} />
          <Route path="accounts" element={user.role === 'admin' ? <AccountAdmin /> : <Navigate to="/overview" replace />} />
          <Route path="providers" element={user.role === 'admin' ? <AIProviderAdmin /> : <Navigate to="/overview" replace />} />
          {/* 旧路由兼容重定向，避免旧链接失效 */}
          <Route path="workflow" element={<Navigate to="/overview" replace />} />
          <Route path="skill" element={<Navigate to="/analysis" replace />} />
          <Route path="director" element={<Navigate to="/strategy" replace />} />
        </Route>
      </Routes>
    </ProjectProvider>
  );
};

function App() {
  return (
    <AuthProvider>
      <div className="demo-app">
        <AppInner />
      </div>
    </AuthProvider>
  );
}

export default App;
